/* eslint-disable no-undef */
import styled from 'styled-components';
import { 
  StyledInputContainer as BaseStyledInputContainer,
  StyledInputNewP1 as BaseStyledInputNewP1,
  StyledModal
} from './styles';

// Extended styled components with props for department popup
export const DepartmentStyledInputContainer = styled(BaseStyledInputContainer)`
  ${({isDepartmentPopup}) => isDepartmentPopup && `
    display: flex;
    height: 60px;
    padding: 0px 16px 0px 8px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-radius: 8px;
    background: #FEFEFE;
    width: 100%;
  `}
`;
export const DepartmentStyledModal = styled(StyledModal)`
  .modal-dialog {
    .modal-content {
      display: flex;
      width: 432px;
      padding: 16px 24px;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      border-radius: 12px;
      background-color: #F8F8F8;
    }
    .modal-header {
      border-bottom: 0;
      padding: 0;
      width: 100%;
      background-color: transparent !important;
      background: transparent !important;
      height: auto !important;
    }
    .modal-body {
      padding: 0;
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }  
  }
`;

// Create directly rather than extending
export const DepartmentStyledInputWrapper = styled.div`
  position: relative;
  width: 100%;
  ${'' /* margin-bottom: 8px; */}
`;

export const DepartmentStyledInputNewP1 = styled(BaseStyledInputNewP1)`
  ${({isDepartmentPopup}) => isDepartmentPopup && `
    background-color: transparent;
    padding: 8px 0;
    font-family: 'Lato';
    font-size: 16px;
    font-weight: 400;
    border: none;
    color: #184A61;
    height: 24px;
    line-height: 24px;
    
    ::placeholder {
      color: #184A61;
      opacity: 0.5;
      font-family: 'Lato', sans-serif;
      font-size: 16px;
    }
  `}
`;

// Create directly rather than extending
export const DepartmentDeleteIconWrapper = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 20px;
    height: 20px;
    
    path {
      fill: #F37A65;
    }
  }
`;

export const AddDepartmentButton = styled.div`
  display: flex;
  width: 200px;
  height: 40px;
  color:#184A61;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px; 
  border  : 1px solid #F37A65;
  border-radius: 4px; 
`;

export const SaveUpdatesButton = styled.div`
  display: flex;
  width: 200px;
  height: 40px;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color:white;
  border-radius: 4px;
  background: #F37A65;
  margin: 0 auto;
  cursor:pointer;
  ${'' /* margin-top: 20px; */}
`;

export const DepartmentTitle = styled.div`
  color: #184A61;
  font-family: 'Lato';
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 12px;
  ${'' /* margin-left: 8px; */}
  align-self: flex-start;
`;

export const DepartmentHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  
  span {
    color: #184A61;
    font-family: 'Lato', sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
  }
`;

export const CloseButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 14px;
    height: 14px;
  }
`;

export const DepartmentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DividerLine = styled.hr`
  border: none;
  border-top: 1px solid #EFEFEF;
  width: 100%;
`; 